import Page, { getStaticProps } from './[...path]';

export default Page;
export { getStaticProps };
